import { Either, Left, Right } from 'fp-ts/lib/Either'
import superagent from 'superagent'

import { log } from '@/log'
import GameCompleteResult from '@/models/game/response/complete'
import GameStartResult from '@/models/game/response/start'
import { ApiClient } from './client'
import { ApiService } from './service'

const namespace: string = 'game'

export default class GameService extends ApiService {

  async postStart(data: object): Promise<Either<Error, GameStartResult>> {
    // 現状はブランド名の指定は不要。エンジン側の対応状況により指定が必要になる可能性あり
    const endpoint = 'game/start'

    try {
      const response = await this.post(endpoint, data)
      log.debug({ service: `${namespace}/post/${endpoint}`, response })

      return new Right(new GameStartResult(response.body.data))
    } catch (error) {
      log.error({ service: `${namespace}/post/${endpoint}`, error })

      return new Left(error)
    }
  }

  async postComplete(data: object, brandEnglishName?: string): Promise<Either<Error, GameCompleteResult>> {
    const endpoint = this.makeCompleteEndpoint(brandEnglishName)

    try {
      const response = await this.post(endpoint, data)
      log.debug({ service: `${namespace}/post/${endpoint}`, response })

      return new Right(new GameCompleteResult(response.body.data))
    } catch (error) {
      log.error({ service: `${namespace}/post/${endpoint}`, error })

      return new Left(error)
    }
  }

  async postCompleteScoreGame(data: object, brandEnglishName?: string): Promise<Either<Error, GameCompleteResult>> {
    const endpoint = this.makeCompleteScoreGameEndpoint(brandEnglishName)

    try {
      const response = await this.post(endpoint, data)
      log.debug({ service: `${namespace}/post/${endpoint}`, response })

      return new Right(new GameCompleteResult(response.body.data))
    } catch (error) {
      log.error({ service: `${namespace}/post/${endpoint}`, error })

      return new Left(error)
    }
  }

  private async post(endpoint: string, data: object): Promise<superagent.Response> {

    return await ApiClient
      .post(`/api/${endpoint}`)
      .send(data)
  }

  private makeCompleteEndpoint(brandEnglishName?: string): string {

    if (brandEnglishName && brandEnglishName.length > 0) {

      return  `${brandEnglishName}/game/complete`
    }

    return 'game/complete'
  }

  private makeCompleteScoreGameEndpoint(brandEnglishName?: string): string {

    if (brandEnglishName && brandEnglishName.length > 0) {

      return  `${brandEnglishName}/game/complete-score-game`
    }

    return 'game/complete-score-game'
  }
}
